import React, { FC } from 'react'

export const ArrowIcon: FC<{ color?: string }> = ({
    color = 'currentColor',
}) => {
    return (
        <svg
            width="14.82"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                d="M10 6L8.59 7.41L13.17 12L8.59 16.59L10 18L16 12L10 6Z"
                fill={color}
            />
        </svg>
    )
}
